import { useState } from "react";
import { Alert, Tabs } from "antd";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";
import { PageHead } from "../components/dashboard/Kpi";
import { ChecklistTab } from "../components/admin/ChecklistTab";
import { ConfigTab } from "../components/admin/ConfigTab";
import { UsersTab } from "../components/admin/UsersTab";
import { PermMatrix } from "../components/admin/PermMatrix";
import { LogTab } from "../components/admin/LogTab";
import { NotificationsTab } from "../components/admin/NotificationsTab";
import { DemoTab } from "../components/admin/DemoTab";
import { ApiTab } from "../components/admin/ApiTab";
import { PrivacyTab } from "../components/admin/PrivacyTab";
import { IntegrityTab } from "../components/admin/IntegrityTab";
import { ProgrammeTemplatesTab } from "../components/admin/ProgrammeTemplatesTab";
import { Card } from "antd";

export default function AdminPage() {
  const { t } = useTranslation();
  const { can } = useAuth();
  const [params] = useSearchParams();
  const [tab, setTab] = useState(params.get("tab") ?? "usr");
  if (!can("admin")) return <Alert type="warning" showIcon message={t("notAllowed")} />;
  return (
    <div>
      <PageHead title={t("admin")} />
      <Tabs
        activeKey={tab}
        onChange={setTab}
        destroyOnHidden
        items={[
          { key: "usr", label: t("cfgUsers"), children: <UsersTab /> },
          { key: "chk", label: t("checklist"), children: <ChecklistTab /> },
          { key: "cfg", label: t("a_config"), children: <ConfigTab /> },
          { key: "prg", label: t("pg_adminTab"), children: <ProgrammeTemplatesTab /> },
          { key: "perm", label: t("a_permMatrix"), children: <Card><PermMatrix /></Card> },
          { key: "api", label: t("api_tab"), children: <ApiTab /> },
          { key: "log", label: t("a_changeLog"), children: <LogTab /> },
          { key: "prv", label: t("d_tabPrivacy"), children: <PrivacyTab /> },
          { key: "int", label: t("d_tabIntegrity"), children: <IntegrityTab /> },
          { key: "ntf", label: t("cfgNotif"), children: <NotificationsTab /> },
          { key: "demo", label: t("a_demoData"), children: <DemoTab /> },
        ]}
      />
    </div>
  );
}
